import PropTypes from 'prop-types'
import { SidebarProvider } from '../components/layout/SidebarProvider'

export const MainLayout = ({ children }) => (
  <div className="overflow-hidden" style={{ height: '100dvh' }}>
    <SidebarProvider>{children}</SidebarProvider>
  </div>
)

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
}
